import { Sekcja, Inner, Info, Eyebrow, Details, Detail, Ramka, Actions } from "./styled";
import { handleSectionClick } from "../../../scrollToSection";
import { directionsWebUrl, googleNavigationProps } from "../../../googleMapsLinks";

const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2339.15343438701!2d22.93470847643329!3d54.08956457251422!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46e102397e0af305%3A0xe40107ffae7b0203!2sSerce%20Finans%C3%B3w%20%E2%80%93%20Pawe%C5%82%20Kowalewski%20Po%C5%9Brednik%20kredytowy!5e0!3m2!1spl!2spl!4v1732099365032!5m2!1spl!2spl";

const SpotkajmySie = () => (
  <Sekcja id="kontakt">
    <Inner>
      <Info>
        <Eyebrow>Biuro i kontakt</Eyebrow>
        <h2>Spotkajmy się w Suwałkach albo porozmawiajmy online.</h2>
        <p>Wybierz formę, która jest dla Ciebie wygodna. Obsługujemy klientów z całej Polski.</p>
        <Details>
          <Detail><span>Adres</span><strong>ul. Aleksandry Piłsudskiej 11 lok. U3<br />16-400 Suwałki</strong></Detail>
          <Detail><span>Godziny</span><strong>pon.–pt. 9:00–17:00</strong></Detail>
          <Detail><span>Telefon</span><strong><a href="tel:+48783677616" data-phone-person="justyna">Justyna: 783 677 616</a><a href="tel:+48783737050" data-phone-person="pawel">Paweł: 783 737 050</a></strong></Detail>
          <Detail><span>E-mail</span><strong><a href="mailto:biuro@sercefinansow.pl">biuro@sercefinansow.pl</a></strong></Detail>
        </Details>
        <Actions><a href="#formularz" data-contact-cta onClick={handleSectionClick("formularz")}>Umów rozmowę</a><a {...googleNavigationProps(directionsWebUrl)} data-map-link>Otwórz trasę →</a></Actions>
      </Info>
      <Ramka
        title="Mapa dojazdu do biura Serce Finansów w Suwałkach"
        src={mapUrl}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </Inner>
  </Sekcja>
);

export default SpotkajmySie;

